export default __webpack_public_path__ + "d46fda649e07bbd34405a2dbc52d9391.svg";